import { render, staticRenderFns } from "./GJgrowEventCreate.vue?vue&type=template&id=791a6e9c&scoped=true&"
import script from "./GJgrowEventCreate.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a6e9c",
  null
  
)

export default component.exports